import { jsx as _jsx } from "react/jsx-runtime";
import useDataStore from '../Data/dataStore';
import { API } from '../globalUtils';
import Div from '../Page/Div';
import { Link } from 'react-router-dom';
import FixedContainer from '../Page/FixedContainer';
import RandomShaderAnimation from '../ShaderAnimation/RandomShaderAnimation';
import usePageStore from '../Page/pageStore';
const BespokeSolutionsSection = ({ content, idx, allowOpen, }) => {
    const { pageChangeCount } = usePageStore();
    const data = useDataStore((state) => state.data);
    const { bespoke_title, bespoke_details, bespoke_solutions_button } = data[API.setup] ?? {};
    const logo = data[API.products]?.products?.[0]?.logo;
    const animations = (data[API.setup]?.bespoke_animations ?? []).map((item) => item.animation_item);
    const snappy = content.force_snap;
    return (_jsx(FixedContainer, { blocked: !snappy, idx: idx, allowOpen: allowOpen, parentClassName: `bespoke-container`, sliderClassName: `bespoke-wrapper`, children: [
            _jsx(Div, { blocked: !allowOpen && snappy, className: "bespoke-animation", delay: 0, noScale: true, children: !!logo && allowOpen && (_jsx(RandomShaderAnimation, { animations: animations, isBespoke: true, refresh: pageChangeCount })) }, "0"),
            _jsx(Div, { blocked: !allowOpen && snappy, className: "bespoke-title", delay: 1, noScale: true, children: bespoke_title }, "1"),
            _jsx(Div, { blocked: !allowOpen && snappy, className: "bespoke-details", delay: 2, noScale: true, children: bespoke_details }, "2"),
            _jsx(Div, { blocked: !allowOpen && snappy, className: "bespoke-button", delay: 3, noScale: true, children: _jsx(Link, { to: bespoke_solutions_button?.url, "aria-label": "Visit Solutions", children: _jsx("div", { className: "button", children: bespoke_solutions_button?.title }) }) }, "3"),
        ] }));
};
export default BespokeSolutionsSection;
